<div class="container">
  <app-template [title]="'Email'">
    <mat-tab-group>
      <mat-tab label="New Email">
        <form [formGroup]="Form">
          <div class="form">
            <!-- <span class="input">
              <mat-form-field>
                <mat-label>Subject</mat-label>
                <input formControlName="Subject" matInput placeholder="" />
              </mat-form-field>
            </span> -->
            <!-- <span class="input">
              <mat-form-field>
                <mat-label>Receiver</mat-label>
                <input formControlName="Receiver" matInput placeholder="" />
              </mat-form-field>
            </span> -->
            <span class="input">
              <mat-form-field>
                <mat-label>Template</mat-label>
                <mat-select
                  formControlName="DocTemplateId"
                  matNativeControl
                  required
                >
                  <mat-option *ngIf="isLoading">Loading Data</mat-option>
                  <mat-option
                    *ngFor="let template of templates"
                    (click)="setTemplate(template)"
                    [value]="template.Id"
                  >
                    {{ template.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field class="size">
                <mat-label>Start Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="dob"
                  (dateChange)="DateChangeStart($event)"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="dob"
                ></mat-datepicker-toggle>
                <mat-datepicker #dob></mat-datepicker>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field class="size">
                <mat-label>End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="ed"
                  (dateChange)="DateChangeEnd($event)"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="ed"
                ></mat-datepicker-toggle>
                <mat-datepicker #ed></mat-datepicker>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>gender</mat-label>
                <mat-select
                  [(ngModel)]="gender"
                  matNativeControl
                  required
                  [ngModelOptions]="{ standalone: true }"
                >
                  <mat-option value="Male">Male</mat-option>
                  <mat-option value="Female">Female</mat-option>
                </mat-select>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Min Age</mat-label>
                <input
                  type="number"
                  [(ngModel)]="minAge"
                  matInput
                  placeholder=""
                  [ngModelOptions]="{ standalone: true }"
                />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Max Age</mat-label>
                <input
                  type="number"
                  [(ngModel)]="maxAge"
                  matInput
                  placeholder=""
                  [ngModelOptions]="{ standalone: true }"
                />
              </mat-form-field>
            </span>
            <div style="position: relative">
              <!-- <button
                (click)="togle()"
                type="button"
                style="margin-top: 10px; margin-left: 30px"
                mat-raised-button
                color="primary"
              >
                Item Of Service</button
              > -->
              <span style="padding-left: 20px">{{ item }}</span>
              <div
                class="mobile"
                *ngIf="isVisible"
                [@simpleFadeAnimation]="'in'"
              >
                <div class="mobile_nav">
                  <div class="service">
                    <table style="width: 100%">
                      <tr class="back">
                        <th>
                          <input
                            type="text"
                            class="form-control"
                            id="search-text"
                            aria-describedby="search-text"
                            [(ngModel)]="searchText"
                            placeholder="Search items"
                            autofocus
                            [ngModelOptions]="{ standalone: true }"
                          />
                        </th>
                        <th>Price</th>
                      </tr>
                      <tr
                        *ngFor="let item of filteredItems"
                        (click)="setitem(item)"
                        style="cursor: pointer"
                      >
                        <td>{{ item.name }}</td>
                        <td>{{ item.service_price }}</td>
                      </tr>
                    </table>
                    <div
                      *ngIf="isLoading"
                      class="spinner"
                      style="margin-top: 40px"
                    >
                      <mat-spinner></mat-spinner>
                    </div>
                    <div class="errorMessage">
                      <div *ngIf="Errors" class="error">
                        <p style="color: aliceblue">{{ Errors }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="space"></div>
            <!-- <quill-editor
              formControlName="MessageBody"
              [styles]="{ height: '300px' }"
            ></quill-editor> -->

            <!-- <div class="errorMessage">
              <div *ngIf="Errors" class="error">
                <p>{{ Errors }}</p>
              </div>
            </div> -->
            <!-- <button
              class="create"
              *ngIf="!isLoading"
              mat-raised-button
              color="primary"
              [disabled]="prev.length == 0"
              (click)="Submit()"
              type="button"
            >
              Send
            </button>
            <button
              class="create"
              *ngIf="isLoading"
              mat-raised-button
              color="primary"
            >
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </button> -->
            <div class="space"></div>
          </div>
        </form>
      </mat-tab>
      <mat-tab label="Preview">
        <!-- <span class="form">
          <mat-form-field class="size">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="end" [(ngModel)]="DateToSend" />
            <mat-datepicker-toggle
              matSuffix
              [for]="end"
            ></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
          </mat-form-field>
        </span> -->
        <button
          class="create"
          *ngIf="!preLoad"
          style="margin: 30px"
          type="button"
          (click)="preview()"
          mat-raised-button
          color="primary"
        >
          Preview
        </button>
        <button
          class="create"
          *ngIf="preLoad"
          style="margin: 30px"
          mat-raised-button
          color="primary"
        >
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>
        <span>
          <button
            class="create"
            *ngIf="!isLoading"
            mat-raised-button
            color="primary"
            [disabled]="prev.length == 0"
            (click)="Submit('email')"
            type="button"
            style="margin-right: 20px"
          >
            Send Email
          </button>
          <button
            class="create"
            *ngIf="isLoading"
            mat-raised-button
            color="primary"
            style="margin-right: 20px"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
        </span>
        <span>
          <button
            class="create"
            *ngIf="!loading"
            mat-raised-button
            color="primary"
            [disabled]="prev.length == 0"
            (click)="Submit('phone')"
            type="button"
            style="margin-right: 20px"
          >
            Send Message
          </button>
          <button
            class="create"
            *ngIf="loading"
            mat-raised-button
            color="primary"
            style="margin-right: 20px"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
        </span>
        <button
          mat-raised-button
          class="button"
          color="primary"
          style="margin-left: 20px"
          (click)="exportexcel()"
        >
          Export
        </button>
        <div class="all">
          <div class="tests">
            <table style="width: 100%" id="table" *ngIf="!isLoading">
              <tr class="back">
                <th>Name</th>
                <th>Phone No</th>
                <th>Email</th>
                <th>Gender</th>
              </tr>
              <tr class="td" *ngFor="let item of prev" style="cursor: pointer">
                <td>{{ item?.PatientName }}</td>
                <td>{{ item?.PhoneNo }}</td>
                <td>{{ item?.EmailAddress }}</td>
                <td>{{ item?.Gender }}</td>
              </tr>
            </table>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Email Template">
        <div style="margin-left: 60px">
          <div>External Variables</div>
          <span>Name: <span style="color: red">[[name]]</span></span
          >&nbsp; &nbsp;
          <span>Age: <span style="color: red">[[age]]</span></span
          >&nbsp; &nbsp;
          <span>Gender: <span style="color: red">[[sex]]</span></span
          >&nbsp; &nbsp;
          <span>DOB: <span style="color: red">[[DOB]]</span></span> &nbsp;
          &nbsp;
        </div>
        <form [formGroup]="templateForm" (ngSubmit)="onSubmit($event)">
          <div class="form">
            <span class="input">
              <mat-form-field>
                <mat-label>Selct Existing Template</mat-label>
                <mat-select matNativeControl>
                  <mat-option *ngIf="isLoading">Loading Data</mat-option>
                  <mat-option
                    *ngFor="let template of templates"
                    (click)="setTemplateEmail(template)"
                    [value]="template.Id"
                  >
                    {{ template.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Subject</mat-label>
                <input formControlName="Title" matInput placeholder="" />
              </mat-form-field>
            </span>
            <div class="space"></div>
            <quill-editor
              formControlName="Body"
              [styles]="{ height: '300px' }"
            ></quill-editor>

            <div class="errorMessage">
              <div *ngIf="Errors" class="error">
                <p>{{ Errors }}</p>
              </div>
            </div>
            <button
              class="create"
              *ngIf="!isLoading"
              mat-raised-button
              color="primary"
              (click)="newTemplate()"
              type="button"
            >
              Save
            </button>
            <button
              class="create"
              *ngIf="isLoading"
              mat-raised-button
              color="primary"
            >
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </button>

            <button
              class="create"
              *ngIf="!isLoading1"
              mat-raised-button
              color="primary"
              (click)="updateTemplate()"
              type="button"
              style="margin-left: 20px"
            >
              Update
            </button>
            <button
              class="create"
              *ngIf="isLoading1"
              mat-raised-button
              color="primary"
              style="margin-left: 20px"
            >
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </button>
            <div class="space"></div>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
  </app-template>
</div>
